import script from "./BaseSubHeading.vue?vue&type=script&lang=ts"
export * from "./BaseSubHeading.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__